import { makeBetterEnum } from './betterEnum';
import { Teams } from './teams';

export const Flags = makeBetterEnum(
  // Rate Limiter Flags
  'ApiUploadDataRateLimiterLarge',
  'ApiUploadDataRateLimiterDisabled',
  'ApiUploadParquetOptOut',
  'ApiReturnChunkedEncoding',
  'AssetGroupUseNullPcafScore',
  'AssetManagerDataExplorerSyw',
  'AssetManagerFundExportFixScope1',
  'AssetManagerNegativeOutstandingAmount',
  'AssetManagerPcafScore5ValueBasedEstimation',
  'AssetManagerRenameFunds',
  'AssetManagerSkipOrgCheckDuringCompanyMatch',
  'AssetManagerViewEdciFieldsPreset',
  'AssetManagerAlternateDataManagementDownload',
  'AssetManagerAlternateAssetYearDownload',
  'AssetManagerAlternateAssetYearPmviDownload',
  'AssetManagerAlternateAssetCorporateDownload',
  'AssetManagerAlternateAssetCommercialRealEstateDownload',
  'AssetManagerAlternateAssetGroupDownload',
  'AssetManagerAlternateAssetPmviDownload',
  'AssetManagerAlternateAssetSovereignDebtDownload',
  'AssetManagerAlternateHoldingPmviDownload',
  'AssetManagerUseSAndPData',
  'AssetManagerUseSAndPIndustryCodes',
  'AssetManagerEnableAuditReports',
  'AssetManagerSkipSAndPBQSync',
  'AssetManagerStopUsingOverrideStampInForPmvi',
  'AssetManagerRecordAttributionFactorOverride',
  'AssetManagerReduceCeeActivityInferenceBatchSize',
  'AssetManagerUseCeeV3',
  'AssetManagerDoNotGenerateFlagsWhenSAndPDataAvailable',
  'AssetManagerEnableCppibEsgSurvey',
  'AssetManagerRunImportDiffOnDtq',
  'AssetManagerUsePmviMethodology',
  'AssetManagerShouldRenameToPmviInsurancePolicyTerms',
  'AssetManagerLoadTesting',
  'AssetManagerLoadTesting_UseCEEV3',
  'AssetManagerHideBuildingSizeUnitInDataExplorer',
  'AssetManagerHideOldBuildingSizeInDataExplorer',
  'AssetManagerBulkEstimateConcurrency',
  'AssetManagerBulkEstimateConcurrencyFour',
  'AssetManagerBulkEstimateConcurrencyEight',
  'AssetManagerDisableOneSchemaPicklist',
  'AssetManagerSkipAssetGroupBartGenerationAtFinancedEmissions',
  'AssetManagerAllowOriginalPCAFScoreWithCustomAttributionFactor',
  'AssetManagerDisableFlagsPage',
  'AssetManagerHideAssetTrackingTabInFinance',
  'AssetManagerVersionedCEE_Backend',
  'AssetManagerVersionedBEE_Backend',
  'AssetManagerVersionedVEE_Backend',
  'AssetManagerVersionedMoVEE_Backend',
  'AssetManagerVersionedEE_Frontend',
  'AssetManagerVersionedEE_RetainPreviousEstimations',
  'AssetManagerPmviCustomAttributionFactorAndPremiumInput',
  'AssetManagerFixSovereignDebtFootprintSource',
  'BenchmarkRevenueAtRisk',
  'BiDrilldownFacilitiesMeasures',
  'BiDrilldownSupplierMeasures',
  'BiEnableMetricDescriptions',
  'LabsAiAgentAPI',
  'LabsBiDashboards',
  'LabsBiDashboardsAiCopilot',
  'LabsAiAgent',
  'LabsAiAgentNoSubcontractors',
  'BiReadFromActivityDataset',
  'BiIncludeStandardActivityDatasets',
  'EnablePreSetCustomTagsForBuildings',
  'EntFoundEmailRestrictions',
  'EntFoundEnableMfa',
  'EntFoundEnableUserAvatar',
  'EntFoundDisableRouteAccessRequestsToOpal',
  'EntFoundUseAsyncContextPermissionChecking',
  'EntFoundPwnedPasswordCheckBlocking',
  'EntFoundPwnedPasswordCheckNonBlocking',
  'EntFoundOrgStructureSkipApiValidation',
  'DashboardCleanPowerAdvancedEstimation',
  'CleanPowerV2',
  'DemoPlatformEnableForRestrictedOrg',
  'FootprintSuppliersPage',
  'SupplierExpenseCategories',
  'SupplierEngagementSurveys',
  'SupplierFootprintUncollapse',
  'SupplyChainChartsConfigAdvancedControls',
  'SupplyChainUseMeasuredQuantityFromHistoricalEmissions',
  'SupplyChainShowImport',
  'SupplyChainHideArchivedConfigsFromCharts',
  'MeasurementIntegrationsQuickBooks',
  'MeasurementIntegrationsArcadia',
  'MeasurementIntegrationsNetSuite',
  'FY26MeasurementTestingDayOrganization',
  'EnableAdminFootprintTagCreation',
  'FootprintDisableWriteInputQuantities',
  'FootprintProductLevelEmissions',
  'FootprintShowProductModels',
  'AlwaysAllowTcfdQualitative',
  'ReportingIgnoreCdpPlanRestrictions',
  'EmissionsModelMinimizeVariableNameInSql',
  'EnablePublishFileUploadFacilities',
  'ReduxSupplierEngagementBySpend',
  'ReduxExperimentalCalculations',
  'ReduxContributionsIntervalOptimization',
  'ReduxDisableCustomTagsInContributions',
  'ReduxUseLocationBasedEmissions',
  'MultipleDatasourcesPerAdt',
  'ActivityDataAllActivityButton',
  'ActivityDataNumericCustomColumns',
  'Unknown',
  'HideExclusionPreview',
  'FootprintBenchmarksForNonCorporate',
  'DataIngestionValueMappingForCustomersBetaDoNotUseWithoutPermission',
  'DataIngestionValueMappingsVendorRowsExpanded',
  'DataIngestionValueMappingDisableVendorPreviews',
  'ValueMappingSkipSeedingOnUpload',
  'ValueMappingQueuedUpdates',
  'ValueMappingPruneArtifactFileOnRebuild',
  'ValueMappingCheckForPendingUpdates',
  'ValueMappingSkipUnmappedRowValidation',
  'ValueMappingHealthCheckIgnoreLegacyArtifactFailures',
  'BartSqlV2WorkflowDedicatedTaskQueueThreshold',
  'DataIngestionDisableExportFacilitiesDocs',
  'DataIngestionTestCts',
  'DataIngestionUtilitiesIngestionV2',
  'DataIngestionUtilitiesOnlyExtraLargeMode',
  'DataIngestionDirectEntry',
  'DataIngestionAllowUploadsOnActivityDataPage',
  'DataIngestionSkipSendingApprovalFlowEmails',
  'DataIngestionFacilitiesLimitedConcurrency',
  'DataIngestionScanUtilityBills',
  'DataIngestionFacilitiesBartsDedicatedTaskQueue',
  'DataIngestionFacilitiesMergeStrategy',
  'DataIngestionChangelogLoadExtra',
  'DataIngestionNewFacilitiesEnrichment',
  'DataIngestionFacilitiesBartStalenessCheck',
  'DataIngestionDoNotAutoEnableJadParityChecking',
  'DataIngestionUseDatasetOnlyForNewProjects',
  'DataIngestionDynamicOneSchemaBatchSize',
  'DataIngestionAddRowIdColumnToUploads',
  'DisableFinancialMappingAiSuggestions',
  'FootprintGenerationAllowPreEmissionsModelGaActivityData',
  'FootprintGenResolveBatVersionFromMatchers',
  'DataInfraMaterializeTableInTraceAddendum',
  'DataInfraUnpivotTableInTraceAddendum',
  'LogAuditEventsToWorkOs',
  'ShouldUsePreviewDuckDbElastic',
  'ShouldUseTestDuckDbServer',
  'ShouldUseTestTemporalTaskQueue',
  'BulkUploadTaskManagement',
  'ContractOverrideUpsellBenchmarks',
  'SupplyChainGeneralMillsCompanyEngagementEmail',
  'CompleteFiscalYearInOverview',
  'DefaultDrilldownChartsClosed',
  'CalculationMethodologyCustomizationPage',
  'CalculationCustomization',
  'CalculationKeepZerosInPipelineResults',
  'CalculationEnableAlphaReleases',
  'CalculationElasticDuckRunnerThresholds',
  'FootprintGenerationAllowDuckDb1448GB',
  'CmvSelectByDate',
  'DisableFacilitiesGeocoding',
  'ShouldUseExtraLargeDuckDbServer',
  'TurnOffCdpUpdateFeatureOnboardingDialog',
  'CsrdEnableAiExtractedAnswers',
  'CsrdEnableReportQuestionApprovalsForCdp',
  'EnableFacilitiesWaterForGhg',
  'EnableFacilitiesWasteForGhg',
  'SupplyChainCustomSupplierConfig',
  'ByPassChonkerChecker',
  'SupplyChainAdminEditCompany',
  'SupplyChainReopenApprovedTask',
  'DataInfraCreateTempTableInCleanPower',
  'ReportingEnableProgressTracking',
  'ImprovedFootprintExportWithActivityData',
  'FootprintExportWithActivityDataShadowRun',

  // # region Data Infra flags
  'DataInfraBumpMaxExpressionDepthFootAssembly',
  'DataInfraUseDuckDbResourceEstimation',
  'DataInfraOnlyUseDuckDbTestExtraLargeServer',
  'DataInfraOnlyUseDuckDbTestServersForResourceEstimation',
  'DataInfraUseLscriptDateCoalesceOptimization',
  'DataInfraAlwaysSaveDuckdbDebugPayload',
  'DataInfraUseElasticPreviewNonBlocking',
  // # endregion Data Infra flags

  'RebuildValueMappingContextOnDuckDbExtraLarge',
  'DataLineageV2',
  'ActivityDataLineageV2',
  'LocalizationDynamicStrings',
  'EnableEditProductRulesAlways',
  'OrgStructure',
  'OrgStructureAutofillingEnabled',
  'OrgStructureDiscoverColumnsInFootprint',
  'CsrdAvoidedCleanPower',
  'ReportingEnableNewClimateIntelligencePanel',
  'ReportingEnableCdpApi',
  'ReportingShowCdpApiIsDownWarnings',
  'ReportingFreezeConfigEdits',
  'ReportingEnableAiGeneratedAnswers',
  'ReportingEnableAiDraftReferences',
  'ReportingEnableAiDraftFromInternal',
  'ReportingEnableAiAnswerAnalysis',
  'ReportingEnableAiChat',
  'ReportingEnableFlexibleReportingAiChat',
  'ReportingEnableFlexibleReporting',
  'ReportingCanonicalFrameworks',
  'SupplyChainEmissionsExport',
  'EnableCompanyMergingAdmin',
  'DataIngestionDisableOneSchemaAi',
  'DataIngestionFlexibleTasks',
  'DataIngestionCTSHydration',
  'OrganizationDestroyLogEvents',
  'CsrdDataRequirementsValidation',

  // DuckDB Optimizations
  'DataInfraOptimizeGetTracesForFingerprints',

  // FY25 temp pricing flags
  'PricingFy25ReportingModuleTemp',
  'PricingFy25BlockScope1And2Temp',
  'PricingFy25BlockAllScope3Temp',
  'PricingFy25BlockScope3_1Temp',
  'PricingFy25BlockScope3_2Temp',
  'PricingFy25BlockScope3_3Temp',
  'PricingFy25BlockScope3_4Temp',
  'PricingFy25BlockScope3_5Temp',
  'PricingFy25BlockScope3_6Temp',
  'PricingFy25BlockScope3_7Temp',
  'PricingFy25BlockScope3_8Temp',
  'PricingFy25BlockScope3_9Temp',
  'PricingFy25BlockScope3_10Temp',
  'PricingFy25BlockScope3_11Temp',
  'PricingFy25BlockScope3_12Temp',
  'PricingFy25BlockScope3_13Temp',
  'PricingFy25BlockScope3_14Temp',
  'PricingFy25ReductionsModuleTemp',
  'PricingFy25CsrdE1ModuleTemp',
  'PricingFy25CsrdE2ModuleTemp',
  'PricingFy25CsrdE3ModuleTemp',
  'PricingFy25CsrdE4ModuleTemp',
  'PricingFy25CsrdE5ModuleTemp',
  'PricingFy25CsrdSocialAndGovernanceModuleTemp',
  'PricingFy25CsrdReportBuilderModuleTemp',

  'EnableGeneralAnomalyDetection',
  'SendEmailsOnDemoOrTestOrg',

  'IgnoreFootprintRowLimit',
  'EnableFootprintAuditBundleDuckdbResize',
  'FootprintAuditBundlePruneEfs',

  // Temporary to simulate failures and evaluate automated response.
  'DangerousDoNotUseIntentionallyBreakThings',

  // Flag for using Version 2 of the Sovereign Debt CMV
  'AssetManagerUseSovereignDebtV2',

  // Temporary solution for Bupa contract
  'SupplyChainDisableLearningTasks',

  'SupplyChainDisableAutoMappingButton',
  'SupplyChainAutoMap10k',
  'ShowAllLanguages',

  'SupplyChainCleanPowerQuoteEnabled',
  'SupplyChainFilterIngestionToHighCdpDisclosureQuality',
  'SupplyChainShowHiddenCompaniesInIngestionSearch',
  'SupplyChainHideNetworkTasksNavItem',
  'SupplyChainShowCdpEfCreatedInBenchmark',
  'SupplyChainRemove70kLimitForRawVendors',

  'DataIngestionSkipFacilitiesBartsAutoRefreshInFootprintGen',
  'SupplyChainEnableDefaultMappingCompanySearch',

  // #region BI V2
  'BiV2DataExplorer',
  'BiV2DataExplorerShowEnableBeta',
  'BiV2WshQLCustomMetrics',
  'BiV2WshQLPublicIds',
  'BiV2FullMetricList',
  'BiV2DimensionListOptions',
  'BiV2DimensionListOptionsShadow',
  // #endregion

  'BiShowKyotoGasEmissionsMetrics',

  'EnableCustomActivityData',
  'UnlimitNumberOfCustomActivityTypes',
  'ShowMarketAndLocationEfInBI',
  'EditFootprintAssemblyJsonConfig',
  'UseV2SyncPgToParquet',

  'SupplyChainTargetsVsActual',
  'DustBotInProductPrototype',
  'SupplyChainLogarithmicTargetReductionRate',

  // Production Graph
  'ProductFootprintsScope3',
  'ProductFootprintsProductFootprints',
  'ProductFootprintBumpUploadLimit',
  'ProductionGraphViewEditHistory',
  'ProductionGraphBulkRunFlash',
  'ProductFootprintReview',
  'ProductionGraphMockLlmForFlash',
  'ProductionGraphBulkPcfSelection',
  'ProductionGraphBulkEditProjects',
  'ProductFootprintOverviewTab',

  // Crudely track customers who are exempt from AI
  // until we have a more permanent solution
  // https://docs.google.com/spreadsheets/d/16KyBjCW-VtHflQLxFu5p7ofX6Qkqy_If/edit?gid=1818819503#gid=1818819503
  'CustomerAIEnabled',
  'CustomerAIQueryingEnabled',
  // Enables non-data resident AI features for EU customers
  'NonDataResidentAIEnabled',

  'MixpanelSessionRecording',
  'MixpanelAutocapture',

  'SupplierCustomFieldsFullEditDialog',
  'LightThemeSideNavigation',
  'EnableFootprintGenerationErrorEmails',
  'JustAddDataFootprintConfig',
  'JustAddDataFootprintConfigParityChecker',
  'JustAddDataUseExtBartsForProcessingHistoricalEmissions',
  'EnableFlexibleFootprintToggle',
  'ShowFlexibleFootprintConfigTestingOnly',
  'FlexibleFootprintUseSelectStar',
  'RunValidatorsForExtendedBarts',

  // Devex
  'DisableSamplingOrgLevelEscapeHatch',

  // BART -> TSchema migration
  'LodgingDataRegistryOnly',
  'LodgingReadDataRegistry',
  'LodgingDualWriteBlocking',
  'LodgingDualWriteNonBlocking',
  'TravelRailDataRegistryOnly',
  'TravelRailReadDataRegistry',
  'TravelRailDualWriteBlocking',
  'TravelRailDualWriteNonBlocking',
  'SoldVehicleDataRegistryOnly',
  'SoldVehicleReadDataRegistry',
  'SoldVehicleDualWriteBlocking',
  'SoldVehicleDualWriteNonBlocking',
  'LogisticsUpgrade',
  'TravelPrivateJetsUpgradePhase',
  'TravelAirUpgradePhase',
  'VehiclesUpgrade',

  'UseSimpleMessageBroker',
  'ValidateExtBartRowIdsForUpgrader',
  'WriteVirtualColumns',
  'DataLineageDebugMode',
  'Labs',
  'LabsEnergyManagement',
  'LabsSustainabilityMap',
  'LabsEnergyUseIntensity',
  'FinanceEnableAlternateOverviewDownload',
  'FinanceDataManagementFlagsPageNew',

  // Watershed Labs
  'Labs',
  'LabsAiAgent',
  'LabsAiAgentNoSubcontractors',
  'LabsBiDashboards',
  'LabsBiDashboardsAiCopilot',
  'LabsEnergyManagement',
  'LabsSustainabilityMap',
  'LabsEnergyUseIntensity'
);

export type Flags = (typeof Flags)[keyof typeof Flags];

export const FlagStage = makeBetterEnum(
  /** Still being worked on by Eng */
  'Alpha',
  /** Safe to demo, safe to enable for select customers */
  'Beta',
  /** Launched features! Expectation is that these will be removed promptly */
  'GA',
  /** Useful for pricing and testing flags */
  'Permanent'
);

export type FlagStage = (typeof FlagStage)[keyof typeof FlagStage];

// Intended to give CSOL guidance about when to enable a flag and when not
// to enable a flag. Therefore, these should not be team-oriented, but
// feature / product oriented.
export const FeatureTag = makeBetterEnum(
  'CSRD',
  'SupplyChain',
  'OrgStructure',
  // testing and pricing are important flags to let CSOL know when to
  // not use them
  'Pricing',
  'Testing',
  // ... more?
  'ParityCheck',
  'Mapping',
  'Permissions'
);

export type FeatureTag = (typeof FeatureTag)[keyof typeof FeatureTag];

// NOTE: do not use User! This is an experimental feature by Enterprise Foundations
export const TargetType = makeBetterEnum('Organization', 'User');

export type TargetType = (typeof TargetType)[keyof typeof TargetType];

type FeatureFlagMetadataBase = {
  description: string;
  team: Teams;
  featureTags: Array<FeatureTag>;
  // NOTE: do not use User! This is an experimental feature by Enterprise Foundations
  targetType: TargetType;
};

export type FeatureFlagMetadata =
  | (FeatureFlagMetadataBase & {
      stage: Exclude<FlagStage, 'Permanent'>;
      deprecateOn: Date;
    })
  | (FeatureFlagMetadataBase & {
      stage: 'Permanent';
      deprecateOn?: undefined;
    });

// Makes the featureTags & targetType optional to simplify flag creation.
type FeatureFlagMetadataDeclarationBase = {
  description: string;
  team: Teams;
  // Defaults to an empty array in FeatureFlagService.getStaticMetadata
  featureTags?: Array<FeatureTag>;
  // NOTE: do not use User! This is an experimental feature by Enterprise
  // Foundations. Defaults to Organization in
  // FeatureFlagService.getStaticMetadata
  targetType?: TargetType;
};

export type FeatureFlagMetadataDeclaration =
  | (FeatureFlagMetadataDeclarationBase & {
      stage: Exclude<FlagStage, 'Permanent'>;
      deprecateOn: Date;
    })
  | (FeatureFlagMetadataDeclarationBase & {
      stage: 'Permanent';
      deprecateOn?: undefined;
    });

export const featureFlagMetadata: Record<
  Flags,
  FeatureFlagMetadataDeclaration
> = {
  ApiUploadDataRateLimiterLarge: {
    description: 'Enable a higher tier of rate limits for API Uploads',
    team: Teams.DataIngestion,
    stage: FlagStage.Permanent,
  },

  ApiUploadDataRateLimiterDisabled: {
    description: 'Disable API Upload rate limiting for specific organizations',
    team: Teams.DataIngestion,
    stage: FlagStage.Permanent,
  },

  ApiUploadParquetOptOut: {
    description:
      'Use Postgres for API Uploads instead of Parquet. With this flag enabled, upload rate limit is reduced to 50,000 rows per minute.',
    team: Teams.DataIngestion,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2025-11-20'),
  },

  ApiReturnChunkedEncoding: {
    description: 'Enable transfer-encoding: chunked for API responses',
    team: Teams.Infrastructure,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-01-31'),
  },

  AssetGroupUseNullPcafScore: {
    description:
      'Finance: whether or not to use a null PCAF score for asset groups',
    team: Teams.WinFinance,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-02-28'),
  },

  AssetManagerSkipOrgCheckDuringCompanyMatch: {
    description:
      'Finance: Skip org check during company match to enable company match for demo orgs',
    team: Teams.WinFinance,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2026-03-03'),
  },

  AssetManagerViewEdciFieldsPreset: {
    description:
      'Finance: Used to gate access to EDCI fields that will be used reporting for Carlyle - should not be turned on for other orgs, as it depends on having a 1:1 asset <-> fund relationship (see notion documentation)',
    team: Teams.WinFinance,
    stage: FlagStage.Permanent,
  },

  AssetManagerNegativeOutstandingAmount: {
    description: 'Finance: Enable negative outstanding amount in holdings',
    team: Teams.WinFinance,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2026-03-03'),
  },

  AssetManagerRenameFunds: {
    description:
      'Finance: Rename "Funds" to "Lines of business", plus categories, groups, etc.',
    team: Teams.WinFinance,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2026-03-03'),
  },

  AssetManagerDataExplorerSyw: {
    description: 'Finance: Enable SYW for the finance data explorer.',
    team: Teams.WinFinance,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2026-03-03'),
  },

  AssetManagerFundExportFixScope1: {
    description: 'Finance: Fix scope-1 metrics in fund export.',
    team: Teams.WinFinance,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-03-30'),
  },

  AssetManagerPcafScore5ValueBasedEstimation: {
    description:
      'Finance: Enable PCAF score 5 value-based estimation. This should only be enabled for PCAF signatories.',
    team: Teams.WinFinance,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2026-03-03'),
  },

  AssetManagerAlternateDataManagementDownload: {
    description:
      'Finance: when downloading the template from the data management page, use GCS rather than DataGrid',
    team: Teams.WinFinance,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2026-01-03'),
  },

  AssetManagerAlternateAssetYearDownload: {
    description:
      'Finance: when downloading the template from the data management page for asset years, use GCS rather than DataGrid',
    team: Teams.WinFinance,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2026-01-03'),
  },

  AssetManagerAlternateAssetYearPmviDownload: {
    description:
      'Finance: when downloading the template from the data management page for PMVI asset years, use GCS rather than DataGrid',
    team: Teams.WinFinance,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2026-01-03'),
  },

  AssetManagerAlternateAssetCorporateDownload: {
    description:
      'Finance: when downloading the template from the data management page for corporate assets, use GCS rather than DataGrid',
    team: Teams.WinFinance,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2026-01-03'),
  },

  AssetManagerAlternateAssetCommercialRealEstateDownload: {
    description:
      'Finance: when downloading the template from the data management page for commercial real estate assets, use GCS rather than DataGrid',
    team: Teams.WinFinance,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2026-01-03'),
  },

  AssetManagerAlternateAssetGroupDownload: {
    description:
      'Finance: when downloading the template from the data management page for asset groups, use GCS rather than DataGrid',
    team: Teams.WinFinance,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2026-01-03'),
  },

  AssetManagerAlternateAssetPmviDownload: {
    description:
      'Finance: when downloading the template from the data management page for PMVI, use GCS rather than DataGrid',
    team: Teams.WinFinance,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2026-01-03'),
  },

  AssetManagerShouldRenameToPmviInsurancePolicyTerms: {
    description:
      'Finance: whether or not to rename asset/asset year/holdings to PMVIinsurance policy terms',
    team: Teams.WinFinance,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-01-30'),
  },

  AssetManagerAlternateAssetSovereignDebtDownload: {
    description:
      'Finance: when downloading the template from the data management page for sovereign debt, use GCS rather than DataGrid',
    team: Teams.WinFinance,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2026-01-03'),
  },

  AssetManagerAlternateHoldingPmviDownload: {
    description:
      'Finance: when downloading the template from the data management page for PMVI holdings, use GCS rather than DataGrid',
    team: Teams.WinFinance,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2026-01-03'),
  },

  AssetManagerUseSAndPData: {
    description: 'Finance: use S&P data for estimations',
    team: Teams.WinFinance,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2026-03-03'),
  },

  AssetManagerUseSAndPIndustryCodes: {
    description: 'Finance: use S&P industry codes for estimations',
    team: Teams.WinFinance,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-03-03'),
  },

  AssetManagerEnableAuditReports: {
    description:
      'Finance: enables audit reports in the finance product regardless of if they used S&P revenue data',
    team: Teams.WinFinance,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2026-03-03'),
  },

  AssetManagerSkipSAndPBQSync: {
    description:
      'Finance: skip the S&P data BQ sync during snapshot generation',
    team: Teams.WinFinance,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-03-03'),
  },

  AssetManagerStopUsingOverrideStampInForPmvi: {
    description: 'Finance: stop using override stamp in for PMVI estimations',
    team: Teams.WinFinance,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-03-03'),
  },

  AssetManagerReduceCeeActivityInferenceBatchSize: {
    description: 'Finance: reduce batch size for CEE activity inference',
    team: Teams.WinFinance,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-04-03'),
    featureTags: [],
    targetType: TargetType.Organization,
  },

  AssetManagerUseCeeV3: {
    description: 'Finance: Use CEE v3 for company estimate generation',
    team: Teams.WinFinance,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-06-01'),
    featureTags: [],
    targetType: TargetType.Organization,
  },

  AssetManagerDoNotGenerateFlagsWhenSAndPDataAvailable: {
    description:
      'Finance: do not generate flags when S&P data is available for industry, revenue, or asset value.',
    team: Teams.WinFinance,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-03-03'),
    featureTags: [],
    targetType: TargetType.Organization,
  },

  AssetManagerEnableCppibEsgSurvey: {
    description:
      'Finance: flag to enable the data collection for CPPIB ESG survey',
    team: Teams.WinFinance,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-03-03'),
    featureTags: [],
    targetType: TargetType.Organization,
  },

  AssetManagerRunImportDiffOnDtq: {
    description: 'Finance: run import diff workflow on DTQ for stability',
    team: Teams.WinFinance,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-03-03'),
    featureTags: [],
    targetType: TargetType.Organization,
  },

  AssetManagerUsePmviMethodology: {
    description:
      'Finance: use cee_vehicle methodology for pmvi total emission estimations',
    team: Teams.WinFinance,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-03-07'),
    featureTags: [],
    targetType: TargetType.Organization,
  },

  AssetManagerLoadTesting: {
    description: 'Finance: use for orgs intended for load testing',
    team: Teams.WinFinance,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-03-01'),
    featureTags: [],
    targetType: TargetType.Organization,
  },

  AssetManagerLoadTesting_UseCEEV3: {
    description: 'Finance: use CEE v3 for load testing',
    team: Teams.WinFinance,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-03-01'),
    featureTags: [],
    targetType: TargetType.Organization,
  },

  AssetManagerBulkEstimateConcurrency: {
    description:
      'Finance: use for orgs intended for load testing - run two bulkGenerateFootprintEstimatesWorkflow at a time',
    team: Teams.WinFinance,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-03-01'),
    featureTags: [],
    targetType: TargetType.Organization,
  },

  AssetManagerBulkEstimateConcurrencyFour: {
    description:
      'Finance: use for orgs intended for load testing - run four bulkGenerateFootprintEstimatesWorkflow at a time',
    team: Teams.WinFinance,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-03-01'),
    featureTags: [],
    targetType: TargetType.Organization,
  },

  AssetManagerBulkEstimateConcurrencyEight: {
    description:
      'Finance: use for orgs intended for load testing - run eight bulkGenerateFootprintEstimatesWorkflow at a time',
    team: Teams.WinFinance,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-03-01'),
    featureTags: [],
    targetType: TargetType.Organization,
  },

  AssetManagerDisableOneSchemaPicklist: {
    description: 'Finance: disable one schema picklist for finance imports',
    team: Teams.WinFinance,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-01-30'),
    featureTags: [],
    targetType: TargetType.Organization,
  },

  AssetManagerSkipAssetGroupBartGenerationAtFinancedEmissions: {
    description:
      'Finance: skip asset group bart generation at financed emissions step',
    team: Teams.WinFinance,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-03-01'),
    featureTags: [],
    targetType: TargetType.Organization,
  },

  AssetManagerAllowOriginalPCAFScoreWithCustomAttributionFactor: {
    description:
      'Finance: support new finance setting that allow user to use the original PCAF score when custom attribution factor is used',
    team: Teams.WinFinance,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-04-01'),
    featureTags: [],
    targetType: TargetType.Organization,
  },

  AssetManagerHideBuildingSizeUnitInDataExplorer: {
    description: 'Finance: hide building size unit metric in the data explorer',
    team: Teams.WinFinance,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-03-01'),
    featureTags: [],
    targetType: TargetType.Organization,
  },

  AssetManagerHideOldBuildingSizeInDataExplorer: {
    description: 'Finance: hide old building size metric in the data explorer',
    team: Teams.WinFinance,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-03-01'),
    featureTags: [],
    targetType: TargetType.Organization,
  },

  AssetManagerVersionedCEE_Backend: {
    description: 'Finance: use versioned CEE backend',
    team: Teams.WinFinance,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-03-31'),
    featureTags: [],
    targetType: TargetType.Organization,
  },

  AssetManagerVersionedBEE_Backend: {
    description: 'Finance: use versioned BEE backend',
    team: Teams.WinFinance,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-03-31'),
    featureTags: [],
    targetType: TargetType.Organization,
  },

  AssetManagerVersionedVEE_Backend: {
    description: 'Finance: use versioned VEE backend',
    team: Teams.WinFinance,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-03-31'),
    featureTags: [],
    targetType: TargetType.Organization,
  },

  AssetManagerVersionedMoVEE_Backend: {
    description: 'Finance: use versioned MoVEE backend',
    team: Teams.WinFinance,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-03-31'),
    featureTags: [],
    targetType: TargetType.Organization,
  },

  AssetManagerVersionedEE_Frontend: {
    description: 'Finance: use versioned EE frontend',
    team: Teams.WinFinance,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-03-31'),
    featureTags: [],
    targetType: TargetType.Organization,
  },

  AssetManagerVersionedEE_RetainPreviousEstimations: {
    description:
      'Finance: retain previous estimations when versioned EE is used. This flag is to be used in combination with AssetManagerVersionedXEE_Backend flags.',
    team: Teams.WinFinance,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-08-30'),
    featureTags: [],
    targetType: TargetType.Organization,
  },

  AssetManagerDisableFlagsPage: {
    description: 'Finance: disable loading flags on flags page',
    team: Teams.WinFinance,
    stage: FlagStage.Permanent,
    targetType: TargetType.Organization,
  },

  AssetManagerHideAssetTrackingTabInFinance: {
    description: 'Finance: hide asset tracking tab in finance',
    team: Teams.WinFinance,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-03-15'),
    featureTags: [],
    targetType: TargetType.Organization,
  },

  AssetManagerPmviCustomAttributionFactorAndPremiumInput: {
    description:
      'Finance: allow custom attribution factor & premium input for personal motor vehicle insurance',
    team: Teams.WinFinance,
    stage: FlagStage.Permanent,
    featureTags: [],
    targetType: TargetType.Organization,
  },

  BenchmarkRevenueAtRisk: {
    description:
      'Expose the revenue at risk card in Benchmarks (FY2024-Q2)  #ask-supply-chain-and-company-data',
    team: Teams.SupplyChain,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },

  BiDrilldownFacilitiesMeasures: {
    description:
      'Shows the facilities measures in the BI drilldown view #ask-datasets-n-objects',
    team: Teams.DatasetsAndObjects,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-04-01'),
  },
  BiDrilldownSupplierMeasures: {
    description:
      'Shows the supplier measures in the BI drilldown view #ask-datasets-n-objects',
    team: Teams.DatasetsAndObjects,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-04-01'),
  },

  EnablePreSetCustomTagsForBuildings: {
    description:
      'Enable data collection tasks _for facilities_ to have pre-set custom tag values. These are derived from custom tags added to buildings. #proj-org-structure',
    team: Teams.ApplicationPlatform,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },

  DashboardCleanPowerAdvancedEstimation: {
    description:
      'Dashboard includes clean power module (2022-Q4). #team-sharing',
    team: Teams.SupplyChain,
    // only enabled for demo orgs so should probably be removed?
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2025-08-07'),
  },

  CleanPowerV2: {
    description: 'Enable clean power v2 user experience and allocation.',
    team: Teams.Calcprint,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-08-19'),
  },

  DemoPlatformEnableForRestrictedOrg: {
    description:
      'If enabled, allows demo platform to be run manually for restricted orgs',
    team: Teams.ApplicationPlatform,
    stage: FlagStage.GA,
    deprecateOn: new Date('2025-08-07'),
  },

  EntFoundEmailRestrictions: {
    description:
      'This is a long-lived contractual commitment flag to turn off click handling and modify how links are displayed in product and emails. It was originally created for Morgan Stanley. See ENT-1848',
    team: Teams.ApplicationPlatform,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2025-08-07'),
  },
  EntFoundEnableMfa: {
    description:
      'Enable MFA to establish the identity of the user, enabled on an org by org basis',
    team: Teams.ApplicationPlatform,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2025-12-01'),
  },

  EntFoundEnableUserAvatar: {
    description: 'Enable avatar upload on user profile settings page',
    team: Teams.ApplicationPlatform,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-08-01'),
  },

  EntFoundDisableRouteAccessRequestsToOpal: {
    description:
      'Disable routing admin org access requests to Opal and use internal auto-approval instead as an escape hatch when Opal is down',
    team: Teams.ApplicationPlatform,
    stage: FlagStage.Permanent,
    featureTags: [],
    targetType: TargetType.Organization,
  },

  EntFoundUseAsyncContextPermissionChecking: {
    description:
      'Use async context to track whether we checked permissions during a GraphQL request. This is a temporary flag while we figure out if this is safe in production',
    team: Teams.ApplicationPlatform,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2025-10-01'),
  },

  EntFoundPwnedPasswordCheckBlocking: {
    description:
      'Check passwords against the Have I Been Pwned API when setting a password. This will block login if the password is breached. This takes priority over the non-blocking flag.',
    team: Teams.ApplicationPlatform,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-02-01'),
    targetType: TargetType.User,
  },

  EntFoundPwnedPasswordCheckNonBlocking: {
    description:
      'Check passwords against the Have I Been Pwned API without blocking login. If pwned, mark the user record.',
    team: Teams.ApplicationPlatform,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2025-02-01'),
    targetType: TargetType.User,
  },

  EntFoundOrgStructureSkipApiValidation: {
    description:
      'Skip org structure validation when uploading data via the API',
    team: Teams.ApplicationPlatform,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2026-04-01'),
    featureTags: [FeatureTag.OrgStructure],
  },

  FootprintSuppliersPage: {
    description: 'Display Suppliers page under Footprint #team-supply-chain',
    team: Teams.SupplyChain,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },

  SupplierExpenseCategories: {
    description:
      'Enable showing and surveying expense categories for suppliers, aka DiscloseEmissionsV2',
    team: Teams.SupplyChain,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },

  SupplierEngagementSurveys: {
    description:
      'Paid supplier engagement add-ons, including supplier KPI metrics, pre-loaded data about supplier emissions, supplier engagement surveys, supplier maturity scoring, and custom columns) #team-supply-chain',
    team: Teams.SupplyChain,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },

  SupplierFootprintUncollapse: {
    description:
      'If true, use uncollapsed footprint fields on the suppliers page. This is potentially expensive; ask before enabling! #team-supply-chain',
    team: Teams.SupplyChain,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },

  SupplyChainChartsConfigAdvancedControls: {
    description:
      'Enable supply chain advanced configs in product. #team-supply-chain',
    team: Teams.SupplyChain,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },

  // See https://www.notion.so/watershedclimate/Importing-historical-spend-data-into-supply-chain-for-Procurewise-customers-20ae2b76a3fb806bbc04ca97e9c90da9
  SupplyChainUseMeasuredQuantityFromHistoricalEmissions: {
    description:
      'Use measured quantity from historical emissions instead of input quantity. This is a workaround for Procurewise customers only.',
    team: Teams.SupplyChain,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2025-08-07'),
  },

  SupplyChainShowImport: {
    description:
      'Enable supply chain import in product. See https://www.notion.so/watershedclimate/Emitwise-data-migration-plan-1f6e2b76a3fb805293b7d396bae0e057',
    team: Teams.SupplyChain,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2025-08-07'),
  },

  SupplyChainHideArchivedConfigsFromCharts: {
    description: 'Hide the archived engagement task configs from charts',
    team: Teams.SupplyChain,
    stage: FlagStage.Permanent,
  },

  MeasurementIntegrationsQuickBooks: {
    description: 'Measurement Integrations (2022-C1) #team-measurement-product',
    team: Teams.DataIngestion,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },

  MeasurementIntegrationsArcadia: {
    description: 'Measurement Integrations (2022-C1) #team-measurement-product',
    team: Teams.DataIngestion,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },

  MeasurementIntegrationsNetSuite: {
    description: 'Measurement Integrations (2022-C1) #team-measurement-product',
    team: Teams.DataIngestion,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },

  FY26MeasurementTestingDayOrganization: {
    description:
      'Enabled for organizations used during FY26 Measurement Testing Day',
    team: Teams.Engineering,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-12-31'),
  },

  FootprintDisableWriteInputQuantities: {
    description:
      'Disable writing input quantities during footprint gen, this will disable product-level measurements from being uploaded which power the "Products & materials" tab when `FootprintProductLevelEmissions` is enabled',
    team: Teams.SupplyChain,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },

  FootprintProductLevelEmissions: {
    description:
      'Describes whether product level measurements, powered by emissions models, are enabled. If this is enabled, then the user will have a new tab for "Products & materials" in their Footprint, and the ability to see lifecycle maps for either products or materials. https://www.notion.so/watershedclimate/Emissions-models-7754b2fd2f474f4caaa940a1b8882d6b',
    team: Teams.SupplyChain,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },

  FootprintShowProductModels: {
    description:
      "If `FootprintProductLevelEmissions` is on, this flag controls which experience the user sees - if it's on, the user will see emissions models for their products, whereas if it's off, the user will see emissions models for their materials instead.",
    team: Teams.SupplyChain,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },

  AlwaysAllowTcfdQualitative: {
    description:
      'Org-level override to allow qualitative TCFD sections no matter what plan they are on. This is to abide by contractual obligations we have with certain organizations.',
    team: Teams.Reporting,
    stage: FlagStage.Permanent,
  },

  ReportingEnableFlexibleReporting: {
    description: 'Enable access to the flexible reporting feature',
    team: Teams.Reporting,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-04-01'), // when this date hits, we should consider moving to beta
  },

  // Note: this flag is not explicitly referenced in any code, but it is being implicitly used by the CDP report config.
  ReportingIgnoreCdpPlanRestrictions: {
    description:
      'Ignore the ordinary CDP plan restrictions for a particular customer.',
    team: Teams.Reporting,
    stage: FlagStage.Permanent,
  },

  ReportingFreezeConfigEdits: {
    description: 'Freeze Reporting config edits.',
    team: Teams.Reporting,
    stage: FlagStage.Permanent,
  },

  ReportingEnableAiGeneratedAnswers: {
    description: 'Enable AI-generated answers for reports',
    team: Teams.Reporting,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-06-01'),
  },
  ReportingEnableAiDraftReferences: {
    description:
      'Allow users to upload references for AI report drafting. This is only used in development, and the feature will be the default when released.',
    team: Teams.Reporting,
    stage: FlagStage.Permanent,
  },
  ReportingEnableAiDraftFromInternal: {
    description:
      'Use internal uploaded files for answer generation. Used for customers with SA derived Risk Assessments',
    team: Teams.Reporting,
    stage: FlagStage.Permanent,
  },
  ReportingEnableAiAnswerAnalysis: {
    description: 'Enable AI-powered answer analysis for reports',
    team: Teams.Reporting,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-06-01'),
  },
  ReportingEnableAiChat: {
    description: 'Enable AI chat functionality for reports',
    team: Teams.Reporting,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-06-01'),
  },
  ReportingEnableFlexibleReportingAiChat: {
    description: 'Enable AI chat functionality for flexible reporting',
    team: Teams.Reporting,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-06-01'),
  },
  ReportingCanonicalFrameworks: {
    description: 'Enable canonical frameworks for reporting',
    team: Teams.Reporting,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-08-31'),
  },
  EmissionsModelMinimizeVariableNameInSql: {
    description: 'Minimize variable name in the SQL generated from lscript.',
    team: Teams.Calcprint,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },

  EnablePublishFileUploadFacilities: {
    description:
      '2023-Q2: Enable publishing file upload facilities AutoBARTs. Without this flag, file uploads are only used to push back into the buildings survey (which will ultimately generate an AutoBART with all buildings in it).',
    team: Teams.DataIngestion,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },

  ReduxSupplierEngagementBySpend: {
    description:
      '2023-Q2: Enables supplier engagement by spend targets in redux #team-reduction-targets',
    team: Teams.Reductions,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },

  ReduxDisableCustomTagsInContributions: {
    description:
      '2024-Q1: Disables custom tags from returning in the footprint for large customers #team-europe-epd',
    team: Teams.Reductions,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },

  ReduxExperimentalCalculations: {
    description:
      '2023-Q3: Enable experimental calculation rewrite modes #team-reduction-targets',
    team: Teams.Reductions,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },
  ReduxContributionsIntervalOptimization: {
    description:
      '2024-Q2: Fetch fewer contributions for non-reference year intervals.',
    team: Teams.Reductions,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },
  ReduxUseLocationBasedEmissions: {
    description: 'FY25-Q3: Use location-based emissions in reduction plans',
    team: Teams.Reductions,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },

  MultipleDatasourcesPerAdt: {
    description:
      '2023-Q1: In the ADT create/edit dialogs, whether to allow choosing multiple datasources per ADT. All backend logic is migrated to the new ActivityDataTableDatasource model for this, but this lets us slow roll the availability to CDAs.',
    team: Teams.DataIngestion,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },

  ActivityDataAllActivityButton: {
    description:
      '2024-Q2: NOT READY FOR CUSTOMERS! Whether to show the "View all activity data" button. #ask-datasets-n-objects',
    team: Teams.DatasetsAndObjects,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-04-01'),
  },

  ActivityDataNumericCustomColumns: {
    description:
      '2024-Q4: NOT READY FOR CUSTOMERS! Allows users to aggregate numeric custom columns from activity data in BI',
    team: Teams.DatasetsAndObjects,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-04-01'),
  },
  Unknown: {
    description:
      'A catch-all id for unknown feature flags. Used as a backstop in our coercion code.',
    team: Teams.Engineering,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },

  HideExclusionPreview: {
    description:
      "Hide the footprint preview in the exclusion rule editor. See CPT-5217: This can be unblock customers until the page's performance problems are fixed.",
    team: Teams.Calcprint,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },

  FootprintBenchmarksForNonCorporate: {
    description:
      '2023-Q2 If enabled, show benchmarks on the footprint overview page for non-corporate footprints.',
    team: Teams.Calcprint,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },

  DataIngestionValueMappingForCustomersBetaDoNotUseWithoutPermission: {
    description:
      '2023-Q4 If enabled, shows the new data ingestion value mapping experience (for Financials datasets only, ex. Capital Expenses), and allows users to edit value mapping. This is the full experience for Financials value mapping. #proj-value-mapping',
    team: Teams.DataIngestion,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
    featureTags: [FeatureTag.Mapping],
  },

  DataIngestionValueMappingsVendorRowsExpanded: {
    description:
      '2024-Q1 If enabled, enables value mappings with vendors to show additional vendors per account.',
    team: Teams.DataIngestion,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
    featureTags: [FeatureTag.Mapping],
  },

  DataIngestionValueMappingDisableVendorPreviews: {
    description:
      '2023-Q4 If enabled, stops showing vendor previews (for Financials datasets only, ex. Capital Expenses) in product.',
    team: Teams.DataIngestion,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
    featureTags: [FeatureTag.Mapping],
  },

  DataIngestionDisableExportFacilitiesDocs: {
    description:
      '2023-Q4 If enabled, removes the ability for users to export their facilities supporting docs',
    team: Teams.DataIngestion,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },

  DataIngestionTestCts: {
    description:
      'Provides access to a super secret, hardly even real test CTS to be used to migrate to Data Registry',
    team: Teams.DataIngestion,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },

  DataIngestionUtilitiesIngestionV2: {
    description:
      '2025-Q1 If enabled, use the V2 utilities push workflows with better batch processing and more resilience to timeouts',
    team: Teams.DataIngestion,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-01-01'),
    targetType: TargetType.Organization,
  },
  DataIngestionUtilitiesOnlyExtraLargeMode: {
    description:
      '2025-Q1 If enabled, pare down facilities functionality so that the product works for large utilities uploads',
    team: Teams.DataIngestion,
    stage: FlagStage.Permanent,
  },

  DataIngestionAllowUploadsOnActivityDataPage: {
    description:
      '2024-Q2 If enabled, allows users to upload files on the activity data page',
    team: Teams.DataIngestion,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2025-08-07'),
  },

  DataIngestionSkipSendingApprovalFlowEmails: {
    description:
      '2025-Q1 If enabled, skips sending approval flow emails in tasks.',
    team: Teams.DataIngestion,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
    featureTags: [],
    targetType: TargetType.Organization,
  },

  DataIngestionScanUtilityBills: {
    description:
      '2025-Q2 If enabled, use the automated data ingestion flow from the activity data page',
    team: Teams.DataIngestion,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2025-08-07'),
    featureTags: [],
    targetType: TargetType.Organization,
  },

  DataIngestionFacilitiesLimitedConcurrency: {
    description:
      '2025-Q2 If enabled, use a lower concurrency limit for generating facilities barts',
    team: Teams.DataIngestion,
    stage: FlagStage.Permanent,
    featureTags: [],
    targetType: TargetType.Organization,
  },

  DataIngestionFacilitiesBartsDedicatedTaskQueue: {
    description:
      '2025-Q2 If enabled, use a dedicated task queue for generating facilities barts',
    team: Teams.DataIngestion,
    stage: FlagStage.Permanent,
    featureTags: [],
    targetType: TargetType.Organization,
  },

  DataIngestionNewFacilitiesEnrichment: {
    description: '2025-Q3 If enabled, use the new facilities enrichment',
    team: Teams.DataIngestion,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-02-01'),
  },

  DataIngestionFacilitiesBartStalenessCheck: {
    description:
      '2025-Q4 If enabled, include the organization when checking for stale facilities barts',
    team: Teams.DataIngestion,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-01-15'),
  },

  DataIngestionDoNotAutoEnableJadParityChecking: {
    description:
      'If enabled, new projects will use ADTOnly instead of ADTWithDatasetShadow as the default dataset rollout state, disabling automatic JAD parity checking',
    team: Teams.DataIngestion,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2025-12-01'),
  },

  DataIngestionUseDatasetOnlyForNewProjects: {
    description:
      'If enabled, new measurement projects will use DatasetOnly mode, creating only dataset-based BARTs without ADT-based BARTs',
    team: Teams.DataIngestion,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-09-01'),
  },

  DataIngestionDynamicOneSchemaBatchSize: {
    description:
      'If enabled, OneSchema validation webhook batch size is calculated dynamically based on the number of columns in the schema to avoid payload too large errors',
    team: Teams.DataIngestion,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-04-01'),
  },

  DataIngestionAddRowIdColumnToUploads: {
    description: '2025-Q1 If enabled, add row_id column to uploaded files',
    team: Teams.DataIngestion,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-06-01'),
    targetType: TargetType.Organization,
  },

  DataIngestionFacilitiesMergeStrategy: {
    description: 'FY26-Q2 Upgraded facilities merge strategy',
    team: Teams.DataIngestion,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2025-09-30'),
  },

  DataIngestionChangelogLoadExtra: {
    description:
      '2025-Q3 If enabled, load extra changelog events instead of only 100',
    team: Teams.DataIngestion,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-01-01'),
  },

  DataIngestionDirectEntry: {
    description: '2024-Q3 Enables direct entry of activity data in upload flow',
    team: Teams.DataIngestion,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2025-08-07'),
  },

  DisableFinancialMappingAiSuggestions: {
    description:
      '2024-Q2 #team-calculation Disables suggestions based on large language models. These customers have opted out of AI suggestions',
    team: Teams.Calcprint,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
    featureTags: [FeatureTag.Mapping],
  },

  DataInfraMaterializeTableInTraceAddendum: {
    description:
      '2024-Q4 Materialize the table in the trace addendum. https://www.notion.so/watershedclimate/Trace-addendum-computation-131e2b76a3fb802b9bb7e5b34845ff8a',
    team: Teams.DataInfrastructure,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2025-08-07'),
  },

  DataInfraUnpivotTableInTraceAddendum: {
    description:
      '2026-Q1 Use UNPIVOT to replace N shard tables in trace addendum.',
    team: Teams.DataInfrastructure,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-06-01'),
  },

  LogAuditEventsToWorkOs: {
    description:
      '2023-Q2 Log audit events to workos #ask-enterprise-readiness #security #team-application-platform',
    team: Teams.ApplicationPlatform,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },

  ShouldUsePreviewDuckDbElastic: {
    description:
      'Route ElasticDuckRunner traffic to the production-preview Temporal namespace.',
    team: Teams.DataInfrastructure,
    stage: FlagStage.Permanent,
  },

  ShouldUseTestDuckDbServer: {
    description:
      '2023-Q3 Use duckdb-server-test for all duckdb-server requests.',
    team: Teams.DataInfrastructure,
    stage: FlagStage.Permanent,
  },

  ShouldUseTestTemporalTaskQueue: {
    description: 'Use test task queue for Temporal workflows.',
    team: Teams.Infrastructure,
    stage: FlagStage.Permanent,
  },

  BulkUploadTaskManagement: {
    description:
      '2023-Q3 Show a dialog to create and reassign upload tasks. #ask-data-ingestion',
    team: Teams.DataIngestion,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },

  ContractOverrideUpsellBenchmarks: {
    description:
      'Contract override upsell for Benchmarks feature. Ideally to be replaced in FY24-Q3 with a permanent solution pulling from SFDC. See #proj-watershed-plan https://watershedclimate.slack.com/archives/C03GUFDA4MC/p1691506636142849?thread_ts=1686153981.781159&cid=C03GUFDA4MC',
    team: Teams.Engineering,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },

  SupplyChainGeneralMillsCompanyEngagementEmail: {
    description:
      "2023-Q3 General Mills' custom email template for company engagement. #ask-supply-chain",
    team: Teams.SupplyChain,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },

  CompleteFiscalYearInOverview: {
    description:
      "2023-Q3 Enables showing trailing 12m intervals in the Overview page according to the org's fiscal year. Requested by Jefferies.  #ask-calcprint",
    team: Teams.Calcprint,
    stage: FlagStage.Permanent,
  },

  DefaultDrilldownChartsClosed: {
    description:
      '2023-Q3 Feature flag to default not open / load drilldown charts #ask-supply-chain',
    team: Teams.SupplyChain,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },

  CalculationMethodologyCustomizationPage: {
    description:
      '2023-Q3 Org-level toggle to enable the emissions factors customization page in product (commonly called "MCU"/methodology customization, but not to be confused with the calculation customization experience being built Q2 2025) #ask-calculation #proj-methodology-customization',
    team: Teams.Calcprint,
    stage: FlagStage.Permanent,
  },

  CalculationCustomization: {
    description:
      '2025-Q2 Feature flag to enable the new calculation customization experience #ask-calculation #proj-calculation-customization',
    team: Teams.Calcprint,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2026-02-01'),
  },

  CalculationKeepZerosInPipelineResults: {
    description:
      '2023-Q4 When enabled zero input quantity is never filtered from pipeline result creation from emissions model evaluations.',
    team: Teams.Calcprint,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },

  CalculationEnableAlphaReleases: {
    description:
      '2024-Q2 Enables alpha releases to be selected as part of the footprint config flow in product.',
    team: Teams.Calcprint,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2025-08-07'),
  },

  CalculationElasticDuckRunnerThresholds: {
    description:
      'Adjusts ElasticDuckRunner resource estimation thresholds for calculation operations in footprint generation workflows when elastic compute is already enabled.',
    team: Teams.Calcprint,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-06-01'),
  },

  FootprintGenerationAllowDuckDb1448GB: {
    description:
      'Allows routing DuckDB workloads to the 1448Gi machines for special customers.',
    team: Teams.Calcprint,
    stage: FlagStage.Permanent,
  },

  CmvSelectByDate: {
    description:
      '2025-Q2 Enables new CMV selection UI that replaces tiles with always-editable table and adds methodology filter for expense rows.',
    team: Teams.Calcprint,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-01-31'),
  },

  DisableFacilitiesGeocoding: {
    description:
      'Acts as an override to disable geocoding of facilities building addresses, which is ordinarily enabled by PricingFy25CsrdE3ModuleTemp. #team-win-csrd',
    team: Teams.DataIngestion,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },

  ShouldUseExtraLargeDuckDbServer: {
    description:
      'Deprecated. Use Resource Estimation. FY2024-Q4 to add an extra large duckdb server. #duckdb',
    team: Teams.DataInfrastructure,
    stage: FlagStage.Permanent,
  },

  TurnOffCdpUpdateFeatureOnboardingDialog: {
    description:
      'FY2024-Q4 Failsafe to urn off CDP update feature onboarding dialog in case dialog goes wonky',
    team: Teams.Reporting,
    stage: FlagStage.Permanent,
  },

  CsrdEnableAiExtractedAnswers: {
    description: 'FY2025-Q3 Enables AI extracted answers in CSRD report',
    team: Teams.ReportingAI,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-01-01'),
  },

  EnableFacilitiesWaterForGhg: {
    description:
      'FY2025-Q1 Enables entry of water data via the utilities modal and IDI templates. https://www.notion.so/watershedclimate/Water-Waste-States-b721f93a23a84b32a16b24ca1630d22d',
    team: Teams.DataIngestion,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },

  EnableFacilitiesWasteForGhg: {
    description:
      'FY2025-Q1 Enables entry of waste data via the utilities modal and IDI templates. https://www.notion.so/watershedclimate/Water-Waste-States-b721f93a23a84b32a16b24ca1630d22d',
    team: Teams.DataIngestion,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },

  SupplyChainCustomSupplierConfig: {
    description: 'FY2025-Q1 Enables custom supplier config UI',
    team: Teams.SupplyChain,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },

  ByPassChonkerChecker: {
    description: 'By passes ChonkerChecker file size checks. #ask-calculation',
    team: Teams.Calcprint,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },

  CsrdEnableReportQuestionApprovalsForCdp: {
    description:
      "FY2026-Q1 Additional gating for approvals in CDP reports (This feature flag will be deprecated with the old reporting platform, and Reporting won't work on this anymore.)",
    team: Teams.Reporting,
    stage: FlagStage.Permanent,
  },

  SupplyChainReopenApprovedTask: {
    description:
      'Enables re-opening approved tasks. Full context here: https://watershedclimate.slack.com/archives/C03A2JW2RS6/p1711469873204239 #ask-supply-chain-and-company-data',
    team: Teams.SupplyChain,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },

  // #region Data infra flags

  // TODO: remove this jawn
  DataInfraCreateTempTableInCleanPower: {
    description:
      'Test DuckDB memory benefits of creating a temporary table before writing to parquet during clean power portion of footprint assembly.',
    team: Teams.DataInfrastructure,
    stage: FlagStage.GA,
    deprecateOn: new Date('2025-08-07'),
  },
  DataInfraBumpMaxExpressionDepthFootAssembly: {
    description:
      'Bumps the max expression depth for footprint assembly queries to 2000 when there are too many pipeline results.',
    team: Teams.DataInfrastructure,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },
  DataInfraUseDuckDbResourceEstimation: {
    description:
      'For use while rolling out new Resource Estimation in DuckDB. Using to ensure we safely move traffic between servers.',
    team: Teams.DataInfrastructure,
    stage: FlagStage.GA,
    deprecateOn: new Date('2025-08-07'),
  },
  DataInfraOnlyUseDuckDbTestExtraLargeServer: {
    description:
      'Do not use unless you are on Data Infra. This moves traffic to an XL test server for DuckDB for use in load testing.',
    team: Teams.DataInfrastructure,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2025-08-07'),
  },
  DataInfraOnlyUseDuckDbTestServersForResourceEstimation: {
    description:
      'Do not use unless you are on Data Infra. For Resource Estimation load test. Uses both XL and regular test DuckDb instances.',
    team: Teams.DataInfrastructure,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2025-08-07'),
  },
  DataInfraUseLscriptDateCoalesceOptimization: {
    description:
      'For use while rolling out a new Lscript optimization. Using flag so we can safely roll back if needed.',
    team: Teams.DataInfrastructure,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2025-08-07'),
  },
  DataInfraAlwaysSaveDuckdbDebugPayload: {
    description:
      'We save a DuckDB debug payload on failures, but lets save it always for orgs with this flag on.',
    team: Teams.DataInfrastructure,
    stage: FlagStage.Permanent,
  },
  DataInfraOptimizeGetTracesForFingerprints: {
    description:
      'Optimization in FootprintAnalysis to improve Data Lineage performance.',
    team: Teams.DataInfrastructure,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-03-01'),
  },
  DataInfraUseElasticPreviewNonBlocking: {
    description:
      '2026-Q1 Sends background DuckDB traffic to both the primary DuckRunner and to elastic compute preview services.',
    team: Teams.DataInfrastructure,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-09-01'),
  },
  // #endregion Data infra flags

  RebuildValueMappingContextOnDuckDbExtraLarge: {
    description:
      'For some customers rebuilding value mapping context requires extra large DuckDB server. Will be removed once they use resource estimation instead.',
    team: Teams.DatasetsAndObjects,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-04-01'),
  },
  LocalizationDynamicStrings: {
    description: 'Load translations for dynamic strings',
    team: Teams.ApplicationPlatform,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },
  EnableEditProductRulesAlways: {
    description:
      'Temporary flag allowing to edit product rules (recat and dedup) even if there is no draft footprint or active measurement project.',
    team: Teams.Calcprint,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2025-08-07'),
  },
  OrgStructure: {
    description:
      'FY2025-Q2  #team-application-platform Enables all org structure capabilities.',
    team: Teams.ApplicationPlatform,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
    featureTags: [FeatureTag.OrgStructure],
  },
  OrgStructureAutofillingEnabled: {
    description:
      'FY2025-Q2  #team-application-platform Enables the autofilling feature of org structure, should only be used if an org has a complete org structure.',
    team: Teams.ApplicationPlatform,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
    featureTags: [FeatureTag.OrgStructure],
  },
  OrgStructureDiscoverColumnsInFootprint: {
    description:
      'Enables discovery of org_unit_* columns from ExtBART parquet data during footprint assembly, even when org structure is unpublished.',
    team: Teams.ApplicationPlatform,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-08-01'),
    featureTags: [FeatureTag.OrgStructure],
  },
  CsrdAvoidedCleanPower: {
    description:
      'FY2025-Q2 #proj-e1-quant Calculate avoided emissions and track clean power contractual instrument from facilities through to reporting.',
    team: Teams.Reporting,
    stage: FlagStage.Permanent,
  },
  ReportingEnableNewClimateIntelligencePanel: {
    description:
      "FY2025-Q2 #team-win-csrd Enables the new climate intelligence panel. (This feature flag will be deprecated with the old reporting platform, and Reporting won't work on this anymore.)",
    team: Teams.Reporting,
    stage: FlagStage.Permanent,
  },
  ReportingEnableCdpApi: {
    description: 'Enable CDP 2025 sync',
    team: Teams.Reporting,
    stage: FlagStage.Permanent,
  },
  // Flipped on for all orgs when CDP is down, shows a message to the user.
  ReportingShowCdpApiIsDownWarnings: {
    description:
      'FY2025-Q3 - Enables warnings in the report-editor when CDP inevitably goes down during CDP-submission-time',
    team: Teams.Reporting,
    stage: FlagStage.Permanent,
  },
  ReportingEnableProgressTracking: {
    description:
      "Enable progress tracking for reporting  (This feature flag will be deprecated with the old reporting platform, and Reporting won't work on this anymore.)",
    team: Teams.Reporting,
    stage: FlagStage.Permanent,
  },
  ImprovedFootprintExportWithActivityData: {
    description: 'Improved footprint export that includes activity data',
    team: Teams.Calcprint,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-03-01'),
  },
  FootprintExportWithActivityDataShadowRun: {
    description:
      'Shadow mode: run new footprint export logic in background for comparison/validation without affecting primary flow',
    team: Teams.Calcprint,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-03-01'),
  },
  SendEmailsOnDemoOrTestOrg: {
    description:
      'FY2025-Q2 #team-application-platform Actions that trigger emails will trigger emails, even on demo or test orgs.',
    team: Teams.ApplicationPlatform,
    stage: FlagStage.Permanent,
  },
  SupplyChainAdminEditCompany: {
    description:
      'We block direct creation and modification of companies in admin so that our company data remains clean. All company creation should go through ingestion. This should only be flipped on by the supply chain team for certain exceptions and then flipped off once the company is added.',
    team: Teams.SupplyChain,
    stage: FlagStage.Permanent,
  },
  SupplyChainEmissionsExport: {
    description:
      'NOTE: THIS SHOULD NOT BE TURNED ON FOR ANY CUSTOMER. This is intended as a Watershed-internal tool to view emissions YoY for suppliers, to be then aggregated for customers. This export should never be shared with a customer - we should only share emissions at an aggregate level, as per CDP contract.',
    team: Teams.SupplyChain,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2025-08-07'),
  },
  CsrdDataRequirementsValidation: {
    description:
      'FY2025-Q4 Runs the Data Requirements validation on file uploads. This should be enabled by SDA for customers we want to run the data requirements engine validator on.',
    team: Teams.Reporting,
    stage: FlagStage.Permanent,
  },

  /**
   * BEGIN FY25 Temp pricing flags
   */
  PricingFy25ReportingModuleTemp: {
    description:
      'FY2025-Q2 #team-application-platform Flag to enable the Reporting module for organizations that are not on a Watershed plan.',
    team: Teams.ApplicationPlatform,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },
  PricingFy25BlockScope1And2Temp: {
    description:
      'FY2025-Q2 #team-application-platform If enabled, the user will NOT see any emissions associated with Scopes 1+2 in their footprint.',
    team: Teams.ApplicationPlatform,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },
  PricingFy25BlockAllScope3Temp: {
    description:
      'FY2025-Q2 #team-application-platform If enabled, the user will NOT see any emissions associated with Scope 3 in their footprint.',
    team: Teams.ApplicationPlatform,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },
  PricingFy25BlockScope3_1Temp: {
    description:
      'FY2025-Q2 #team-application-platform If enabled, the user will NOT see any emissions associated with Scope 3.1 in their footprint.',
    team: Teams.ApplicationPlatform,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },
  PricingFy25BlockScope3_2Temp: {
    description:
      'FY2025-Q2 #team-application-platform If enabled, the user will NOT see any emissions associated with Scope 3.2 in their footprint.',
    team: Teams.ApplicationPlatform,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },
  PricingFy25BlockScope3_3Temp: {
    description:
      'FY2025-Q2 #team-application-platform If enabled, the user will NOT see any emissions associated with Scope 3.3 in their footprint.',
    team: Teams.ApplicationPlatform,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },
  PricingFy25BlockScope3_4Temp: {
    description:
      'FY2025-Q2 #team-application-platform If enabled, the user will NOT see any emissions associated with Scope 3.4 in their footprint.',
    team: Teams.ApplicationPlatform,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },
  PricingFy25BlockScope3_5Temp: {
    description:
      'FY2025-Q2 #team-application-platform If enabled, the user will NOT see any emissions associated with Scope 3.5 in their footprint.',
    team: Teams.ApplicationPlatform,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },
  PricingFy25BlockScope3_6Temp: {
    description:
      'FY2025-Q2 #team-application-platform If enabled, the user will NOT see any emissions associated with Scope 3.6 in their footprint.',
    team: Teams.ApplicationPlatform,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },
  PricingFy25BlockScope3_7Temp: {
    description:
      'FY2025-Q2 #team-application-platform If enabled, the user will NOT see any emissions associated with Scope 3.7 in their footprint.',
    team: Teams.ApplicationPlatform,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },
  PricingFy25BlockScope3_8Temp: {
    description:
      'FY2025-Q2 #team-application-platform If enabled, the user will NOT see any emissions associated with Scope 3.8 in their footprint.',
    team: Teams.ApplicationPlatform,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },
  PricingFy25BlockScope3_9Temp: {
    description:
      'FY2025-Q2 #team-application-platform If enabled, the user will NOT see any emissions associated with Scope 3.9 in their footprint.',
    team: Teams.ApplicationPlatform,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },
  PricingFy25BlockScope3_10Temp: {
    description:
      'FY2025-Q2 #team-application-platform If enabled, the user will NOT see any emissions associated with Scope 3.10 in their footprint.',
    team: Teams.ApplicationPlatform,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },
  PricingFy25BlockScope3_11Temp: {
    description:
      'FY2025-Q2 #team-application-platform If enabled, the user will NOT see any emissions associated with Scope 3.11 in their footprint.',
    team: Teams.ApplicationPlatform,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },
  PricingFy25BlockScope3_12Temp: {
    description:
      'FY2025-Q2 #team-application-platform If enabled, the user will NOT see any emissions associated with Scope 3.12 in their footprint.',
    team: Teams.ApplicationPlatform,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },
  PricingFy25BlockScope3_13Temp: {
    description:
      'FY2025-Q2 #team-application-platform If enabled, the user will NOT see any emissions associated with Scope 3.13 in their footprint.',
    team: Teams.ApplicationPlatform,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },
  PricingFy25BlockScope3_14Temp: {
    description:
      'FY2025-Q2 #team-application-platform If enabled, the user will NOT see any emissions associated with Scope 3.14 in their footprint.',
    team: Teams.ApplicationPlatform,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },
  PricingFy25ReductionsModuleTemp: {
    description:
      'FY2025-Q2 #team-application-platform Used to price-gate the reductions module. If enabled, the reductions module will be accessible.',
    team: Teams.ApplicationPlatform,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },
  PricingFy25CsrdE1ModuleTemp: {
    description:
      'FY2025-Q3 #team-win-csrd Used to price-gate the CSRD E21 module. This flag does not control the enablement of measurement, but it does control features that must accompany E1. For example, net revenue uploads and carbon credit retirement views in drilldown.',
    team: Teams.Reporting,
    stage: FlagStage.Permanent,
  },
  PricingFy25CsrdE2ModuleTemp: {
    description:
      'FY2025-Q3 #team-win-csrd Used to price-gate the CSRD E2 module. If enabled, measurement and calculation of E2 metrics will become accessible.',
    team: Teams.Reporting,
    stage: FlagStage.Permanent,
  },
  PricingFy25CsrdE3ModuleTemp: {
    description:
      'FY2025-Q3 #team-win-csrd Used to price-gate the CSRD E3 module. If enabled, measurement and calculation of E3 metrics will become accessible.',
    team: Teams.Reporting,
    stage: FlagStage.Permanent,
  },
  PricingFy25CsrdE4ModuleTemp: {
    description:
      'FY2025-Q3 #team-win-csrd Used to price-gate the CSRD E4 module. If enabled, measurement and calculation of E4 metrics will become accessible.',
    team: Teams.Reporting,
    stage: FlagStage.Permanent,
  },
  PricingFy25CsrdE5ModuleTemp: {
    description:
      'FY2025-Q3 #team-win-csrd Used to price-gate the CSRD E5 module. If enabled, measurement and calculation of E5 metrics will become accessible.',
    team: Teams.Reporting,
    stage: FlagStage.Permanent,
  },
  PricingFy25CsrdSocialAndGovernanceModuleTemp: {
    description:
      'FY2025-Q3 #team-win-csrd Used to price-gate the CSRD S&G module. If enabled, measurement and calculation of S&G metrics will become accessible.',
    team: Teams.Reporting,
    stage: FlagStage.Permanent,
  },
  PricingFy25CsrdReportBuilderModuleTemp: {
    description:
      'FY2025-Q3 #team-win-csrd Used to price-gate the CSRD report builder module. If enabled, users will have access to the CSRD report builder.',
    team: Teams.Reporting,
    stage: FlagStage.Permanent,
  },
  /**
   * END FY25 Pricing Flags
   */
  EnableGeneralAnomalyDetection: {
    description:
      'FY2025-Q2 #ask-datasets-n-objects If enabled, show anomaly detection on activity datasets and drilldown.',
    team: Teams.DatasetsAndObjects,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-04-01'),
  },
  DataIngestionDisableOneSchemaAi: {
    description:
      'Disable OneSchema feature that allows uploads to receive AI-based suggestions',
    team: Teams.DataIngestion,
    stage: FlagStage.Permanent,
  },
  DataIngestionFlexibleTasks: {
    description:
      'WIP. Do not use unless given permission! Enables new abstract data structures for tasks.',
    team: Teams.DataIngestion,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-03-15'),
  },
  DataIngestionCTSHydration: {
    description:
      'When enabled, upload validation uses hydrated target schemas that include org-specific custom columns.',
    team: Teams.DataIngestion,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-03-01'),
  },
  DataLineageV2: {
    description: 'Enable data lineage v2, which uses Transforms',
    team: Teams.Calcprint,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },
  ActivityDataLineageV2: {
    description: 'Enable data lineage v2 for activity data',
    team: Teams.Calcprint,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2025-08-07'),
  },
  IgnoreFootprintRowLimit: {
    description:
      'Disable row limit enforcement for footprints [FOR TESTING ONLY, DO NOT USE FOR CUSTOMERS]',
    team: Teams.Calcprint,
    stage: FlagStage.Permanent,
  },
  EnableFootprintAuditBundleDuckdbResize: {
    description:
      'Enables 343GB DuckDB instance for footprint audit bundle exports. Used as an escape hatch for orgs attempting to export very large. This should be replaced with proper resource estimation.',
    team: Teams.Calcprint,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-06-01'),
  },
  FootprintAuditBundlePruneEfs: {
    description:
      'Prune emissions factor CTE to only the join keys referenced by the footprint export.',
    team: Teams.Calcprint,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-06-01'),
  },

  DangerousDoNotUseIntentionallyBreakThings: {
    description:
      'NOT FOR PUBLIC CONSUMPTION! This flag is used to intentionally break parts of the product and test our automated responses.',
    team: Teams.Engineering,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },
  EnableCompanyMergingAdmin: {
    description: 'Enable company merging in admin (must be flipped globally)',
    team: Teams.SupplyChain,
    stage: FlagStage.Permanent,
  },
  SupplyChainDisableLearningTasks: {
    description:
      "Disable learning engagement tasks from showing up for users since they won't internationalized soon",
    team: Teams.SupplyChain,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2025-08-07'),
  },
  SupplyChainDisableAutoMappingButton: {
    description: 'Disable the automapping button on the supplier mapping page',
    team: Teams.SupplyChain,
    stage: FlagStage.Permanent,
    featureTags: [FeatureTag.Mapping],
  },
  SupplyChainAutoMap10k: {
    description:
      'DO NOT USE WITHOUT PERMISSION FROM EPDS. Allow mapping up to 10k of suppliers by spend (pre-measurement) or emissions (post-measurement). Built for customer escalations only. Reach out to #ask-supply-chain-epds',
    team: Teams.SupplyChain,
    stage: FlagStage.Permanent,
    featureTags: [FeatureTag.Mapping],
  },
  ShowAllLanguages: {
    description:
      'Localization: show all languages even the ones that are in progress and not launched to customers yet.',
    team: Teams.ApplicationPlatform,
    stage: FlagStage.Permanent,
  },
  BiEnableMetricDescriptions: {
    description:
      'Show descriptions for metrics in BI. Behind a FF because we have not audited all of the existing descriptions',
    team: Teams.DatasetsAndObjects,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-03-01'),
  },
  LabsBiDashboards: {
    description: 'Enable access to BI dashboards feature in Watershed Labs',
    team: Teams.Labs,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2025-08-07'),
    targetType: TargetType.User,
  },
  LabsBiDashboardsAiCopilot: {
    description: 'Enable AI copilot functionality within BI dashboards',
    team: Teams.Labs,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2025-12-31'),
    targetType: TargetType.User,
  },
  LabsAiAgentAPI: {
    description: 'Enable MCP endpoint on the public API for external AI agents',
    team: Teams.Labs,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-09-05'),
  },
  LabsAiAgent: {
    description: 'Enable access to the AIRuntime experiment in Watershed Labs',
    team: Teams.Labs,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-07-12'),
    targetType: TargetType.User,
  },
  LabsAiAgentNoSubcontractors: {
    description:
      'Prevent usage of the Labs AI agent for customers that cannot use the new subcontractor',
    team: Teams.Labs,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-07-12'),
    targetType: TargetType.Organization,
  },

  FootprintGenerationAllowPreEmissionsModelGaActivityData: {
    description:
      'Allow pre-emissions model GA activity data to be used in footprint generation',
    team: Teams.Calcprint,
    stage: FlagStage.Permanent,
  },
  FootprintGenResolveBatVersionFromMatchers: {
    description:
      'Kill switch: when enabled, footprint gen reads the BAT version from ' +
      "each matcher's stored businessActivityTypeId. When disabled (default), " +
      'footprint gen resolves the latest BAT version at runtime (CPT-4640).',
    team: Teams.Calcprint,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-06-01'),
  },
  DataIngestionSkipFacilitiesBartsAutoRefreshInFootprintGen: {
    description:
      'Skip auto-refreshing facilities BARTs in footprint generation, instead only refresh the BARTs that are stale',
    team: Teams.DataIngestion,
    stage: FlagStage.GA,
    deprecateOn: new Date('2025-08-07'),
  },
  SupplyChainEnableDefaultMappingCompanySearch: {
    description:
      'Enable running the company search for the supplier mapping page by default',
    team: Teams.SupplyChain,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2025-08-07'),
    featureTags: [FeatureTag.Mapping],
  },
  SupplyChainCleanPowerQuoteEnabled: {
    description:
      'Enable the option to get a clean power quote from the marketplace page. This is a temporary flag as we fully deprecate this feature.',
    team: Teams.SupplyChain,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2025-08-07'),
  },
  SupplyChainFilterIngestionToHighCdpDisclosureQuality: {
    description:
      'Ingestion queue only shows diffs corresponding to CDP vendor data of high or very high disclosure quality score for the most recent publishing year. This ensures company ingestion focuses on the rows we will create EFs for.',
    team: Teams.SupplyChain,
    stage: FlagStage.Permanent,
  },
  SupplyChainShowHiddenCompaniesInIngestionSearch: {
    description:
      'Ingestion queue does not allow matching on hidden companies. This generally makes sense but we might need one-off instances where we do match to a hidden company — such as to unblock CDP EF generation.',
    team: Teams.SupplyChain,
    stage: FlagStage.Permanent,
  },
  SupplyChainHideNetworkTasksNavItem: {
    description: 'Hide the Network Tasks nav item',
    team: Teams.SupplyChain,
    stage: FlagStage.Permanent,
  },
  SupplyChainShowCdpEfCreatedInBenchmark: {
    description: 'Show whether CDP EF was created for a company in benchmark',
    team: Teams.SupplyChain,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2025-08-07'),
  },
  SupplyChainRemove70kLimitForRawVendors: {
    description: 'Remove the 70k limit for raw vendors',
    team: Teams.SupplyChain,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2025-08-07'),
  },
  BiV2DataExplorer: {
    description:
      'Enable a toggle for the new data explorer UX for BI, including new field picker and query controls',
    team: Teams.DatasetsAndObjects,
    stage: FlagStage.Beta,
    deprecateOn: new Date('2026-03-01'),
  },
  BiV2DataExplorerShowEnableBeta: {
    description:
      'Show the permissions modal in the new data explorer UX for BI',
    team: Teams.DatasetsAndObjects,
    stage: FlagStage.GA,
    deprecateOn: new Date('2026-03-01'),
  },
  BiV2WshQLCustomMetrics: {
    description: 'Use WshQL to define arbitrary custom metrics',
    team: Teams.DatasetsAndObjects,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-03-01'),
  },
  BiV2WshQLPublicIds: {
    description: 'Use public schema ids in WshQL queries',
    team: Teams.DatasetsAndObjects,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-04-01'),
  },
  BiV2FullMetricList: {
    description: 'Enable the full metric list in BI',
    team: Teams.DatasetsAndObjects,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-04-01'),
  },
  BiV2DimensionListOptions: {
    description:
      'Use the new dimension list options logic in the BI query service',
    team: Teams.DatasetsAndObjects,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-03-01'),
  },
  BiV2DimensionListOptionsShadow: {
    description:
      'Shadow test the new dimension list options logic against V1 in production',
    team: Teams.DatasetsAndObjects,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-04-01'),
  },
  BiShowKyotoGasEmissionsMetrics: {
    description: 'Show Kyoto gas emissions metrics',
    team: Teams.Methodology,
    stage: FlagStage.GA,
    deprecateOn: new Date('2026-03-01'),
  },
  BiReadFromActivityDataset: {
    description:
      'Whether BI should use ActivityDataset rather than legacy activity APIs to load activity data.',
    team: Teams.DatasetsAndObjects,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-04-01'),
  },
  BiIncludeStandardActivityDatasets: {
    description:
      'Whether BI should include Standard Activity Datasets, which include data from Just Add Data, or just the Legacy Activity Datasets.',
    team: Teams.DatasetsAndObjects,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-04-01'),
  },
  EnableCustomActivityData: {
    description:
      'Enable custom activity data and limit the number of custom activity types that can be created to 5',
    stage: FlagStage.Alpha,
    team: Teams.DatasetsAndObjects,
    deprecateOn: new Date('2026-04-01'),
  },
  UnlimitNumberOfCustomActivityTypes: {
    description:
      'Allow unlimited number of custom activity types to be created',
    team: Teams.DatasetsAndObjects,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-04-01'),
  },
  ValueMappingSkipSeedingOnUpload: {
    description: `Do not use if you are not on DNO team! This is a temporary flag to cause Value Mapping not to seed right after a file upload completes. It's meant to alleviate issues caused from a sudden burst of API uploads, which can cause too much DuckDB pressure and some concurrency bugs. Use it in tandem with the manual workflow reseedAllFinancialValueMappingsWorkflow, and turn off the flag after running that workflow. Once we fix those concurrency problems, we can delete this flag.`,
    team: Teams.DatasetsAndObjects,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-04-01'),
  },
  ValueMappingCheckForPendingUpdates: {
    description:
      'Enable a cron job that checks for pending value mapping updates and kicks off their processing',
    team: Teams.DatasetsAndObjects,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-04-01'),
  },
  ValueMappingQueuedUpdates: {
    description:
      'Enable queued value mapping updates to be processed via workflows',
    team: Teams.DatasetsAndObjects,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-04-01'),
  },
  ValueMappingSkipUnmappedRowValidation: {
    description:
      'Skip validation of unmapped rows when approving value mapping records',
    team: Teams.DatasetsAndObjects,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-04-01'),
  },
  ValueMappingPruneArtifactFileOnRebuild: {
    description:
      'Prune the financial value mappings artifact file on full rebuild',
    team: Teams.DatasetsAndObjects,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-04-01'),
  },
  ValueMappingHealthCheckIgnoreLegacyArtifactFailures: {
    description:
      'Ignore artifact health check failures caused by files that were uploaded before the new queued update model went live.',
    team: Teams.DatasetsAndObjects,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-08-01'),
  },
  BartSqlV2WorkflowDedicatedTaskQueueThreshold: {
    description:
      'Lower the DTQ threshold for BartSqlV2Workflow to use a dedicated task queue. This should be used only as a break-glass approach for failing workflows.',
    team: Teams.DatasetsAndObjects,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-08-01'),
  },
  OrganizationDestroyLogEvents: {
    description: 'Destroy LogEvents when deleting an organization',
    team: Teams.ApplicationPlatform,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2025-08-07'),
  },
  EnableAdminFootprintTagCreation: {
    description:
      'Escape hatch to re-enable footprint tag creation from the admin footprints page. Tag creation is disabled by default.',
    team: Teams.Calcprint,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-09-01'),
  },
  EditFootprintAssemblyJsonConfig: {
    description:
      'Edit the JSON config in footprint assembly in product directly.',
    team: Teams.Calcprint,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2025-08-07'),
  },
  UseV2SyncPgToParquet: {
    description: 'Use parquet files from V2 of the sync pg to parquet workflow',
    team: Teams.Calcprint,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2025-08-07'),
  },
  SupplyChainTargetsVsActual: {
    description: 'Enable the targets vs actuals view',
    team: Teams.SupplyChain,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2025-08-07'),
  },
  DustBotInProductPrototype: {
    description:
      'INTERNAL ONLY - Enable the Dust Bot in the product prototype.',
    team: Teams.ApplicationPlatform,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2025-08-07'),
  },
  AssetManagerRecordAttributionFactorOverride: {
    description:
      'Flag to add attribution factor override to asset holdings in FE and postgresSQL',
    team: Teams.WinFinance,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-03-03'),
  },
  AssetManagerFixSovereignDebtFootprintSource: {
    description:
      'Flag to hide the newly introduced footprint source field that correctly pulls sovereign debt footprint source while rolling out',
    team: Teams.WinFinance,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-04-04'),
  },
  SupplyChainLogarithmicTargetReductionRate: {
    description:
      'Enable logarithmic reduction rate for company climate targets',
    team: Teams.SupplyChain,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2025-08-07'),
    featureTags: [],
    targetType: TargetType.Organization,
  },
  ProductionGraphBulkRunFlash: {
    description:
      'Enable bulk running FLASH (will only be available for internal Watershed users)',
    team: Teams.ProductionGraph,
    stage: FlagStage.Permanent,
  },
  ProductFootprintReview: {
    description: 'Enable production graph review system',
    team: Teams.ProductionGraph,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-06-01'),
    targetType: TargetType.Organization,
  },
  CustomerAIEnabled: {
    description: 'Customer contract permits AI use',
    team: Teams.AICore,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2025-10-07'),
    targetType: TargetType.Organization,
  },
  CustomerAIQueryingEnabled: {
    description: 'Enables the AI querying page for a customer',
    team: Teams.AICore,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-08-20'),
    targetType: TargetType.User,
  },
  NonDataResidentAIEnabled: {
    description: 'Enables non-data resident AI features for EU customers',
    team: Teams.AICore,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-04-01'),
    targetType: TargetType.Organization,
  },
  SupplierCustomFieldsFullEditDialog: {
    description:
      'Enable the full edit dialog for supplier custom fields. We have this behind a FF because some edits can be destructive and we want to make sure we properly handle those before allowing the user to make those changes',
    team: Teams.SupplyChain,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2025-08-07'),
  },
  LightThemeSideNavigation: {
    description: 'Light theme side navigation',
    team: Teams.ApplicationPlatform,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2025-08-07'),
  },
  MixpanelSessionRecording: {
    description: 'Enable Mixpanel session recording',
    team: Teams.DataIngestion,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2025-08-07'),
  },
  MixpanelAutocapture: {
    description: 'Enable Mixpanel autocapture',
    team: Teams.DataIngestion,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2025-08-07'),
  },
  EnableFootprintGenerationErrorEmails: {
    description:
      'When enabled, sends error emails to users when footprint generation fails. When disabled, errors are only reported to Sentry.',
    team: Teams.Calcprint,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-08-01'),
  },
  FlexibleFootprintUseSelectStar: {
    description:
      'Use SELECT * instead of enumerating columns when querying ExtBARTs in flexible footprint config. This is a bug fix that’s flagged for safety, and we should remove it quickly.',
    team: Teams.DatasetsAndObjects,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-03-15'),
  },
  JustAddDataFootprintConfig: {
    description: 'Enable Just Add Data footprint config',
    team: Teams.DatasetsAndObjects,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-04-01'),
  },
  JustAddDataFootprintConfigParityChecker: {
    description:
      'Causes us to run parity checker on legacy footprint runs against JAD footprint config.',
    team: Teams.DatasetsAndObjects,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-04-01'),
  },
  JustAddDataUseExtBartsForProcessingHistoricalEmissions: {
    description:
      'Use ExtBARTs and no ADEs for processing historical emissions in Just Add Data flexible footprint generation flow.',
    team: Teams.DatasetsAndObjects,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-02-01'),
  },
  EnableFlexibleFootprintToggle: {
    description:
      'Show the toggle to switch between legacy and flexible footprint config in the footprint assembly UI. When on, new footprints use FFC by default and users can switch modes per footprint.',
    team: Teams.DatasetsAndObjects,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-04-01'),
  },
  ShowFlexibleFootprintConfigTestingOnly: {
    description:
      'Show the flexible footprint config internal testing only. This should never be turned on in the backend for any customer, it is purely for frontend overrides to see how customers would experience the flow.',
    team: Teams.DatasetsAndObjects,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-04-01'),
    featureTags: [FeatureTag.Testing],
  },
  RunValidatorsForExtendedBarts: {
    description:
      'Run validators for extended BARTs created with placeholder BARTs. Used for ramping up.',
    team: Teams.DatasetsAndObjects,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-04-01'),
  },
  DisableSamplingOrgLevelEscapeHatch: {
    description:
      'Exclude orgs from having their traces sampled (some traces are dropped)',
    team: Teams.DeveloperExperience,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2025-08-07'),
  },
  LodgingDataRegistryOnly: {
    description: 'Lodging BAT: Use DataRegistryOnly mode',
    team: Teams.DataInfrastructure,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2025-08-07'),
  },
  LodgingReadDataRegistry: {
    description: 'Lodging BAT: Use ReadDataRegistry mode',
    team: Teams.DataInfrastructure,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2025-08-07'),
  },
  LodgingDualWriteBlocking: {
    description: 'Lodging BAT: Use DualWriteBlocking mode',
    team: Teams.DataInfrastructure,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2025-08-07'),
  },
  LodgingDualWriteNonBlocking: {
    description: 'Lodging BAT: Use DualWriteNonBlocking mode',
    team: Teams.DataInfrastructure,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2025-08-07'),
  },
  TravelRailDataRegistryOnly: {
    description: 'Travel Rail BAT: Use DataRegistryOnly mode',
    team: Teams.DataInfrastructure,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2025-08-07'),
  },
  TravelRailReadDataRegistry: {
    description: 'Travel Rail BAT: Use ReadDataRegistry mode',
    team: Teams.DataInfrastructure,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2025-08-07'),
  },
  TravelRailDualWriteBlocking: {
    description: 'Travel Rail BAT: Use DualWriteBlocking mode',
    team: Teams.DataInfrastructure,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2025-08-07'),
  },
  TravelRailDualWriteNonBlocking: {
    description: 'Travel Rail BAT: Use DualWriteNonBlocking mode',
    team: Teams.DataInfrastructure,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2025-08-07'),
  },
  SoldVehicleDataRegistryOnly: {
    description: 'Sold Vehicle BAT: Use DataRegistryOnly mode',
    team: Teams.DatasetsAndObjects,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-04-01'),
  },
  SoldVehicleReadDataRegistry: {
    description: 'Sold Vehicle BAT: Use ReadDataRegistry mode',
    team: Teams.DatasetsAndObjects,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-04-01'),
  },
  SoldVehicleDualWriteBlocking: {
    description: 'Sold Vehicle BAT: Use DualWriteBlocking mode',
    team: Teams.DatasetsAndObjects,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-04-01'),
  },
  SoldVehicleDualWriteNonBlocking: {
    description: 'Sold Vehicle BAT: Use DualWriteNonBlocking mode',
    team: Teams.DatasetsAndObjects,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-04-01'),
  },
  LogisticsUpgrade: {
    description:
      'Logistics BAT: Orgs with this flag on will have an activation setting one higher than those without',
    team: Teams.DatasetsAndObjects,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-04-01'),
  },
  TravelPrivateJetsUpgradePhase: {
    description:
      'Travel Private Jets BAT: Orgs with this flag on will have an activation setting one higher than those without. (TSchema migration)',
    team: Teams.DatasetsAndObjects,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-04-01'),
  },
  TravelAirUpgradePhase: {
    description:
      'Travel Air BAT: Orgs with this flag on will have an activation setting one higher than those without. (TSchema migration)',
    team: Teams.DatasetsAndObjects,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-04-01'),
  },
  VehiclesUpgrade: {
    description:
      'Vehicles BAT: Orgs with this flag on will have an activation setting one higher than those without',
    team: Teams.DatasetsAndObjects,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-04-01'),
  },
  ProductionGraphMockLlmForFlash: {
    description:
      '[INTERNAL ONLY] 2025-Q1 Mock LLM calls in the Flash material mapping system for load testing production graphs. This bypasses the actual AI model calls to enable performance testing without expensive LLM API costs. #team-product-footprints',
    team: Teams.ProductionGraph,
    stage: FlagStage.Permanent,
  },
  ShowMarketAndLocationEfInBI: {
    description: 'Show market and location EF in BI',
    team: Teams.DatasetsAndObjects,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-03-01'),
  },
  UseSimpleMessageBroker: {
    description: 'Use the simple message broker',
    team: Teams.Infrastructure,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2025-08-07'),
  },
  ValidateExtBartRowIdsForUpgrader: {
    description:
      'Enable validation to check for swapped row IDs in ExtBART tables after updater run. This validation ensures data integrity by comparing month fields for ext_bart_row_ids between original and updated tables.',
    team: Teams.DatasetsAndObjects,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-04-01'),
  },
  WriteVirtualColumns: {
    description:
      '[Deprecated] Virtual columns are now always written. This flag will be removed after 2026-03-03.',
    team: Teams.DatasetsAndObjects,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-03-03'),
  },
  DataLineageDebugMode: {
    description:
      '[ENGINEER ONLY] Enable debug mode for data lineage to display additional node information including lineage run/asset IDs, jobSlug, and pointer details.',
    team: Teams.Calcprint,
    stage: FlagStage.Permanent,
  },
  ProductionGraphViewEditHistory: {
    description: 'Enable viewing edit history for production graphs',
    team: Teams.ProductionGraph,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-01-01'),
  },
  ProductionGraphBulkPcfSelection: {
    description: 'Enable bulk PCF selection for materials',
    team: Teams.ProductionGraph,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-02-01'),
  },
  ProductionGraphBulkEditProjects: {
    description: 'Enable bulk edit projects tab in product footprints',
    team: Teams.ProductionGraph,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-07-01'),
  },
  ProductFootprintOverviewTab: {
    description: 'Enable overview tab in product footprints',
    team: Teams.ProductionGraph,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-07-01'),
  },
  Labs: {
    description: 'Show Watershed Labs navigation item in the sidebar',
    team: Teams.Labs,
    stage: FlagStage.Alpha,
    featureTags: [],
    targetType: TargetType.User,
    deprecateOn: new Date('2026-12-31'),
  },
  LabsSustainabilityMap: {
    description: 'Enable Sustainability Map experiment in Watershed Labs',
    team: Teams.Labs,
    stage: FlagStage.Alpha,
    featureTags: [],
    targetType: TargetType.User,
    deprecateOn: new Date('2026-12-31'),
  },
  LabsEnergyManagement: {
    description: 'Enable Energy Management prototype in Watershed Labs',
    team: Teams.Labs,
    stage: FlagStage.Alpha,
    featureTags: [],
    targetType: TargetType.User,
    deprecateOn: new Date('2026-12-31'),
  },
  LabsEnergyUseIntensity: {
    description: 'Enable Energy Use Intensity experiment in Watershed Labs',
    team: Teams.Labs,
    stage: FlagStage.Alpha,
    featureTags: [],
    targetType: TargetType.User,
    deprecateOn: new Date('2026-12-31'),
  },
  ProductFootprintsScope3: {
    description: 'Enable scope 3 SKU',
    team: Teams.ProductionGraph,
    stage: FlagStage.Permanent,
  },
  ProductFootprintsProductFootprints: {
    description: 'Enable product footprints SKU',
    team: Teams.ProductionGraph,
    stage: FlagStage.Permanent,
  },
  ProductFootprintBumpUploadLimit: {
    description:
      'Increase the material variant upload limit from 10k to 50k for product footprints',
    team: Teams.ProductionGraph,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-12-31'),
  },
  FinanceEnableAlternateOverviewDownload: {
    description: 'Enable alternate overview download for finance',
    team: Teams.WinFinance,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-04-01'),
    featureTags: [],
    targetType: TargetType.Organization,
  },
  FinanceDataManagementFlagsPageNew: {
    description: 'Enable new paginated Finance Data Management Flags tab',
    team: Teams.WinFinance,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-04-01'),
    featureTags: [],
    targetType: TargetType.Organization,
  },
  // Temporary MET Finance testing flag
  AssetManagerUseSovereignDebtV2: {
    description: 'Enable use of sovereign debt v2 for finance',
    team: Teams.Methodology,
    stage: FlagStage.Alpha,
    deprecateOn: new Date('2026-04-01'),
    featureTags: [],
    targetType: TargetType.Organization,
  },
};
